/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { parseSideNavExpandedCookies } from '@repo/shared-client/components/blocks'
import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequestHeaders } from '@tanstack/react-start/server'

export const readSideNavSsrCookies = createIsomorphicFn()
  .client(() => parseSideNavExpandedCookies(document.cookie))
  .server(() => {
    try {
      return parseSideNavExpandedCookies(getRequestHeaders().get('cookie') ?? '')
    } catch {
      return {}
    }
  })
